import { GetColumnsType } from '../../../../../ui/components/TableContainer/types/propsTypes';
import { formatDateDMYYYY } from '../../../../../ui/utils';
import { DynamicObjectInterface } from '../../../../../sdk/type';

type IRewardBO = {
  [key: string]: DynamicObjectInterface;
};

const getRewardListConfig: GetColumnsType = (styles: Object, translation: Function, cb: DynamicObjectInterface) => [
  {
    key: 'rewardName',
    text: translation('admin.rewardMaster.rewardName'),
    sortable: true,
    width: 5,
    render: (object: IRewardBO) => <span>{object.rewardName}</span>,
  },
  {
    key: 'redeemDate',
    text: translation('admin.participant.collectDate'),
    sortable: true,
    width: 5,
    render: (object: IRewardBO) => (
      <span>{object.redeemDate ? formatDateDMYYYY(new Date(object.redeemDate)) : null}</span>
    ),
  },
];

export default getRewardListConfig;
